import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, $stateParams, PolicyChangeService, $q, ModalService) => {
    const ctrl = Object.create(BaseCtrl);

    $scope.notes = [];

    ctrl.getNotes = () => {
        $scope.getNotesPromise = PolicyChangeService.getNotesForPolicyChange($stateParams.policyChangeNumber).then(
            (notes) => {
                $scope.notes = notes;
            },
            () => {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.quote-notes.Error loading notes');
            }
        );
    };

    ctrl.getNotes();


    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$stateParams', 'PolicyChangeService', '$q', 'ModalService'];

export default fn;
